import type { UI } from '@/v2/types';

import type { PackageOption as PackageOptionType } from '@shared/v2/utils/getPackageOptions/getPackageOptions';
import { BEST_RATE_ID } from '@shared/v2/constants/packages';
import useAutoSelectBestRates from '@shared/v2/hooks/useAutoSelectBestRates';

import PackageOption from '@/v2/components/ui/PackageOption';
import PackageOptionCard from './PackageOptionCard';
import PackageOptionSlider from './PackageOptionSlider';

interface Props {
  packageOptions: PackageOptionType[] | null | undefined;
  selectedInclusionId?: string;
  onSelectPackageOption: (value: string) => void;
  procuredOffer: UI.ProcuredOffer | null;
  propertyContent: UI.Property;
  disabled: boolean;
}

const PackageOptionContent = ({
  packageOptions,
  selectedInclusionId,
  onSelectPackageOption,
  propertyContent,
  procuredOffer,
  disabled,
}: Props) => {
  useAutoSelectBestRates(!!packageOptions?.length);

  const options = [
    <PackageOption.BestAvailableRates
      key={BEST_RATE_ID}
      selected={selectedInclusionId === BEST_RATE_ID}
      onClickCTA={() => onSelectPackageOption(BEST_RATE_ID)}
      pillText={null}
      disabled={disabled}
    />,
    ...(packageOptions?.map((packageOption: PackageOptionType) => (
      <PackageOptionCard
        key={packageOption.id}
        isSelected={selectedInclusionId === packageOption.id}
        packageOption={packageOption}
        onSelectPackageOption={onSelectPackageOption}
        propertyContent={propertyContent}
        procuredOffer={procuredOffer}
        disabled={disabled}
      />
    )) ?? []),
  ];

  return (
    <PackageOptionSlider
      data-testid="PACKAGE_OPTIONS"
      initialKey={selectedInclusionId}
    >
      {options}
    </PackageOptionSlider>
  );
};

export default PackageOptionContent;
